<template>
    <v-menu
        v-model="open"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        :disabled="setup.readonly"
        color="purple"
        dense
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="setup.dateFormatted"
                @blur="date = parseDate(setup.dateRaw)"
                :label="setup.label"
                :required="setup.required"
                :rules="setup.rule"
                :messages="(setup.checkDateisBeforeNow !== undefined && setup.checkDateisBeforeNow === true) ? checkDateisBeforeNow(setup) : ''"
                :filled="setup.filled"
                prepend-icon="event"
                readonly
                v-on="on"
                :clearable="setup.clearable"
                :class="(customError.length > 0) ? 'error--text' : ''"
                dense
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            no-title
            @input="open = false"
            locale="pt-br"
            :readonly="setup.readonly"
            dense
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'date-picker',
    props: ['setup'],
    data () {
        return {
            open: false,
            date: undefined,
            customError: ''
        }
    },
    watch: {
        'date': function (val) {
            this.setup.dateFormatted = this.formatDate(this.date)
            this.setup.dateRaw = this.date
        },
        'open': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.setup.dateRaw !== undefined) {
                        this.date = this.parseDate(this.setup.dateRaw)
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        formatDate (date) {
            if (!date) return null
            return this.$options.filters.momentFormatDateNoISO(new Date(date), 'D - MMM').toUpperCase()
        },
        parseDate (date) {
            if (!date) return null
            date = date.split('T')[0]
            return date
        },
        checkDateisBeforeNow (setup) {
            if (setup.dateFormatted) {
                const [day, month, year] = setup.dateFormatted.split('/')
                if (day && month && (new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`).toISOString().split('T')[0] < new Date().toISOString().split('T')[0])) {
                    this.customError = 'Data anterior ao presente dia!'
                    return this.customError
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .v-messages
        color yellow

    .error--text
        & >>> i,
        & >>> label,
        & >>> input,
        & >>> div
            color: #ff5252 !important;
            caret-color: #ff5252 !important
</style>
